var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ExternalPlatformsImport } from './external-platforms-import';
import Spinner from '../../../../../app/common/Spinner';
import { usePlatformCredentialsHandlers } from './hooks/use-platform-credentials-handlers';
import { useBarberSelectorHandlers } from './hooks/use-barber-selector-handlers';
import { usePlatformSelectorHandlers } from './hooks/use-platform-selector-handlers';
import { useImportFormHandlers } from './hooks/use-import-form-handlers';
import { Wrapper } from './components/wrapper';
import { platformsConfig } from './platforms-config';
export var ExternalPlatformsImportContainer = function () {
    var _a, _b, _c;
    var barberSelectorHandlers = useBarberSelectorHandlers();
    var platformSelectorHandlers = usePlatformSelectorHandlers();
    var loginAndPasswordHandlers = usePlatformCredentialsHandlers({
        barberId: barberSelectorHandlers.selectedBarberId,
        platform: platformSelectorHandlers.selectedPlatform,
    });
    var importFormHandlers = useImportFormHandlers({
        barberId: barberSelectorHandlers.selectedBarberId,
        platform: platformSelectorHandlers.selectedPlatform,
        brandId: (_a = barberSelectorHandlers.shop) === null || _a === void 0 ? void 0 : _a.brandId,
    });
    if (barberSelectorHandlers.isLoadingBarberData) {
        return (_jsx(Wrapper, { children: _jsx(Spinner, {}) }));
    }
    var isDataNotFoundError = barberSelectorHandlers.selectedBarberId &&
        platformSelectorHandlers.selectedPlatform &&
        !loginAndPasswordHandlers.login &&
        !loginAndPasswordHandlers.isLoadingCredentials &&
        loginAndPasswordHandlers.isErrorCredentials;
    var shouldShowCredentials = !!(!loginAndPasswordHandlers.isLoadingCredentials &&
        !loginAndPasswordHandlers.isErrorCredentials &&
        !isDataNotFoundError &&
        loginAndPasswordHandlers.login &&
        loginAndPasswordHandlers.password);
    var shouldShowImportForm = !!((_b = platformsConfig[platformSelectorHandlers.selectedPlatform]) === null || _b === void 0 ? void 0 : _b.authenticationItemName);
    var shouldShowLoginLink = !!(!loginAndPasswordHandlers.isLoadingCredentials &&
        barberSelectorHandlers.selectedBarberId &&
        ((_c = platformsConfig[platformSelectorHandlers.selectedPlatform]) === null || _c === void 0 ? void 0 : _c.loginPageUrl));
    return (_jsx(ExternalPlatformsImport, __assign({}, barberSelectorHandlers, platformSelectorHandlers, loginAndPasswordHandlers, importFormHandlers, { shouldShowCredentials: shouldShowCredentials, shouldShowImportForm: shouldShowImportForm, shouldShowLoginLink: shouldShowLoginLink, isDataNotFoundError: isDataNotFoundError })));
};
